/**
 * Api.Constant.ts
 * This Component is used to define endpoint commonly.
 */
export const GetTimeZones = "/Config/GetTimeZones";
export const UpdateTimeZonePreference =
  "/UserManagement/UpdateTimeZonePreference";
export const GetScannedProductDetails = "/Project/GetScannedProductDetails";
export const AddEditCrateScanInfo = "/Project/AddEditCrateScanInfo";
export const GetScannedProductList = "/Project/GetScannedProductList";
export const UpdateCrateMapping = "/Project/UpdateCrateMapping";
export const GetScannedCrateList = "/Project/GetScannedCrateList";

export const GetCustomerUploadMasterList =
  "/Project/GetCustomerUploadMasterList";
export const GetCustomerUploadDetailList =
  "/Project/GetCustomerUploadDetailList";

export const GetMasterList = "/Project/GetMasterList";
export const UpdateArchiveStatus = "/Project/UpdateArchiveStatus";
export const GetArchivedRecordList = "/Project/GetArchivedRecordList";
export const UploadDocument = "/Project/UploadDocument";
export const GetTimeLineDetails = "/Project/GetUnitProgressDetails";
export const GetUnitTimeLineDetails = "/Project/GetUnitTimeLineDetail";
export const GetUnitProgressReport = "/Reports/GetUnitProgressReport";

// ***********************************************************************************

export const ApiSignin = "/Auth/SignIn";

// Configuration End Points
export const GetCountryList = "/Config/GetCountryList";
export const GetStateList = "/Config/GetStateList";
export const GetDistrictList = "/Config/GetDistrictList";
export const GetConfigParamDataList = "/Config/GetConfigParamDataList";
export const GetConfigGroups = "/Config/GetConfigGroups";
export const AddEditConfigGroup = "/Config/AddEditConfigGroup";
export const GetSpecificConfigGroup = "/Config/GetSpecificConfigGroup";
export const GetSpecificConfigParamData = "/Config/GetSpecificConfigParamData";
export const AddEditConfigInfo = "/Config/AddEditConfigInfo";
export const GetMenuHierarchyList = "/Config/GetMenuHierarchyList";
export const GetChunkAPICountDtl = "/Config/GetChunkAPICountDtl";
export const GetVersionInfo = "/Config/GetVersionInfo";
export const GetReEditPasswordList = "/Config/GetReEditPasswordList";
export const AddEditReEditPassword = "/Config/AddEditReEditPassword";
export const GetSpecificReEditPassword = "/Config/GetSpecificReEditPassword";
export const ValidateReEditPassword = "/Config/ValidateReEditPassword";

export const GetSpecificUserListPreference =
  "/Config/GetSpecificUserListPreference";
export const UpdateUserListPreference = "/Config/UpdateUserListPreference";

// USER MANAGEMENT
export const GetUserList = "/UserManagement/GetUserList";
export const AddEditUser = "/UserManagement/AddEditUser";
export const GetSpecificUserMasterData =
  "/UserManagement/GetSpecificUserMasterData";
export const GetRoleList = "/UserManagement/GetRoleList";
export const GetSpecificRoleInformation =
  "/UserManagement/GetSpecificRoleInformation";
export const AddOrUpdateRoleInformation =
  "/UserManagement/AddOrUpdateRoleInformation";
export const ValidateOTP = "/UserManagement/ValidateOtp";
export const ChangePassword = "/UserManagement/ChangePassword";
export const GenerateOtp = "/UserManagement/GenerateOtp";
export const ValidateOTPOpen = "/OpenPage/ValidateOtp";
export const ChangePasswordOpen = "/OpenPage/ChangePassword";
export const GenerateOtpOpen = "/OpenPage/GenerateOtp";

// Customer Module End Points
export const GetCustomerList = "/Project/GetCustomerList";
export const AddEditCustomer = "/Project/AddEditCustomer";
export const GetSpecificCustomerData = "/Project/GetSpecificCustomerData";
export const ImportCustomerUploadedList =
  "/BulkUpload/ImportCustomerUploadedList";
export const AddEditCustomerPartnerMapping =
  "/Project/AddEditCustomerPartnerMapping";

// Level 1 process
export const AddEditL1Evaluation = "/Project/AddEditL1Evaluation";
export const GetSpecificLeve1EvalDetails =
  "/Project/GetSpecificLeve1EvalDetails";
export const GetSpecificLevel2EvalDetails =
  "/Project/GetSpecificLevel2EvalDetails";

// Level 2 process
export const AddEditL2Evaluation = "/Project/AddEditL2Evaluation";

// File management module End Points
export const AddEditCustomerUploadMaster =
  "/BulkUpload/AddEditCustomerUploadMaster";
export const DownloadCustomerErrorReport =
  "/BulkUpload/DownloadCustomerErrorReport";
export const GetSavedDocument = "/BulkUpload/GetSavedDocument";

// Bulk Upload End Points
export const ImportDealerList = "/BulkUpload/ImportDealerList";
export const ImportTicketList = "/BulkUpload/ImportTicketList";
export const ImportEngineerList = "/BulkUpload/ImportEngineerList";
export const SaveBulkDealerList = "/BulkUpload/SaveBulkDealerList";
export const ApproveADL = "/BulkUpload/ApproveADL";
export const GetOverallRecordsReport = "/Reports/GetOverallRecordsReport";
export const GetBulkUploadSample = "/Reports/GetBulkUploadSample";
export const GetEngineerUploadSample = "/Reports/GetEngineerUploadSample";
export const GetEnggBulkDataReport = "/Reports/GetEnggBulkDataReport";
export const GetProductStatusCount = "/Reports/GetProductStatusCount";

// Ticket Module End Points
export const AddEditTicket = "/Ticket/AddEditTicket";
export const GetTicketList = "/Ticket/GetTicketList";
export const GetSpecificTicket = "/Ticket/GetSpecificTicket";
export const GetSpecificTicketAMCApproval =
  "/Ticket/GetSpecificTicketAMCApproval";
export const AddEditTicketAMCApproval = "/Ticket/AddEditTicketAMCApproval";
export const ReassignTicket = "/Ticket/ReassignTicket";
export const GetSpareDepHistory = "/Ticket/GetSpareDepHistory";
export const AddEditSpareDependency = "/Ticket/AddEditSpareDependency";
export const DeleteTicket = "/Ticket/DeleteTicket";

// Product Module End Points
export const GetProductList = "/Product/GetProductList";
export const AddEditProduct = "/Product/AddEditProduct";
export const GetSpecificProduct = "/Product/GetSpecificProduct";

// Fault Category Module End Points
export const GetFaultCategoryList = "/Config/GetProblemCategoryList";
export const AddEditFaultCategory = "/Config/AddEditProblemCategory";
export const GetSpecificFaultCategory = "/Config/GetSpecificProblemCategory";

// Stator Used Module End Points
export const GetStatorUsedList = "/Config/GetStatorUsedList";
export const AddEditStatorUsed = "/Config/AddEditStatorUsed";
export const GetSpecificStatorUsed = "/Config/GetSpecificStatorUsed";

// Defect Code Book Module End Points
export const GetDefectLogBook = "/Config/GetDefectLogBook";
export const UploadDefectLogBook = "/Config/UploadDefectLogBook";
export const GetSavedDefectLogBookFile = "/Config/GetSavedDefectLogBookFile";

// Holiday List End Points
export const GetHolidayList = "/Config/GetAllCalendarEvents";
export const AddEditCalendarEvent = "/Config/AddEditCalendarEvent";
export const UpdateChunkAPICount = "/Config/UpdateChunkAPICount";

// Config-state End Points
export const AddEditState = "/Config/AddEditState";
export const AddDistrict = "/Config/AddDistrict";
export const UpdateDistrict = "/Config/UpdateDistrict";
export const GetGroupById = "/Config/GetGroupById";
export const GetIssueCategoryList = "/Config/GetIssueCategoryList";
export const AddEditIssueCategory = "/Config/AddEditIssueCategory";

// Config-spare End Points
export const GetSpareList = "/Product/GetSpareList";
export const AddEditSpare = "/Product/AddEditSpare";
export const AddEditSpareProduct = "/Product/AddEditSpareProduct";
export const GetSpecificSpare = "/Product/GetSpecificSpare";
export const GetSpareProductList = "/Product/GetSpareProductList";

// Logs End Points
export const GetAuditLogList = "/Config/GetAuditLogList";

// Reports End Points,
export const GetAMCSummaryReport = "/Reports/GetAMCSummaryReport";
export const AddEditReportData = "/Reports/AddEditReportData";
export const GetInstallationCostReport = "/Reports/GetInstallationCostReport";
export const GetReportLogsList = "/Reports/GetReportLogsList";
export const GetReportDataList = "/Reports/GetReportDataList";
export const AddEditReportSchedules = "/Reports/AddEditReportSchedules";
export const GetReportSchedulesList = "/Reports/GetReportScheduleList";
export const GetDashboardDailyTicketCount =
  "/Reports/GetDashboardDailyTicketCount";

// Product Rate Module End Points
export const GetCustomerAMCRateList = "/Product/GetCustomerAMCRateList";
export const GetPartnerRateList = "/Product/GetPartnerRateList";
export const AddEditCustomerAMCRate = "/Product/AddEditCustomerAMCRate";
export const AddEditServicePartnerRate = "/Product/AddEditServicePartnerRate";
